import { RESET_STATE } from './actionTypes';

export const resetState = () => {
  return { type: RESET_STATE };
};



// WEBPACK FOOTER //
// ./src/state/actions/app.js